import { Button } from "@material-ui/core";
import { PedidoModel } from "../../../../../model/api/pedidos/pedido-model";
import { CardNaoEncontrado } from "../../../../components/cards/card-nao-encontrado";
import { CardPedidoMotoboy } from "../../../../components/cards/card-pedido-motoboy/card-pedido-motoboy";
import { InformacaoIcon } from "../../../../components/icons";
import { useStyles } from "./motoboy-styles";
import { NovoIcon } from "../../../../components/icons/novo-icon";
import { useHistory } from "react-router-dom";

interface PedidoEntregaProps {
    list: Array<PedidoModel>;
    carregando: boolean;
    handleReloadPedidos: () => void;
}

export const MotoboyData = (props: PedidoEntregaProps) => {

    const classes = useStyles();

    const history = useHistory();

    const handleClick = () => {
        history.push('/adicionar-pedido?modulo=motoboy');
    }

    return (
        <>
            {((props.list ?? []).length === 0) && !props.carregando && (
                <CardNaoEncontrado
                    mensagem="Nenhum Pedido Encontrado."
                    icon={<InformacaoIcon tipo="GERAL" />}
                    button={
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleClick}
                            className={classes.btnAddPedido}
                        >
                            <NovoIcon tipo="BUTTON_PRIMARY" />
                            Adicionar Pedido
                        </Button>
                    }
                />
            )}
            {((props.list ?? []).length > 0) && (
                props.list.map((item) => (
                    <CardPedidoMotoboy
                        key={item.id}
                        pedido={item}
                        handleReloadPedidos={props.handleReloadPedidos}
                    />
                ))
            )}
        </>
    )
}